module.exports = __webpack_public_path__ + "img/Flag_of_Algeria.1f678fcc.svg";